import React from "react";
import { Typography } from "@mui/material";

interface InvitationErrorProps {
  message: string;
}

export const InvitationError: React.FC<InvitationErrorProps> = ({ message }) => {
  return (
    <>
      <Typography
        variant="h5"
        sx={{
          fontWeight: 600,
          color: "#000000",
          mb: 2,
        }}
      >
        Error
      </Typography>
      <Typography
        variant="body1"
        sx={{
          color: "#666666",
          mb: 3,
        }}
      >
        {message}
      </Typography>
    </>
  );
};
